const timezoneInfoObj = {
    "TZ_0000":"Europe/London",
    "TZ_0100":"Europe/Berlin",
    "TZ_0200":"Europe/Kiev",
    "TZ_0300":"Europe/Istanbul",
    "TZ_0630":"Asia/Kolkata",
    "TZ_0700":"Asia/Ho_Chi_Minh",
    "TZ_0800":"Asia/Shanghai",
    "TZ_0900":"Asia/Tokyo",
    "TZ_1400":"Pacific/Honolulu",
    "TZ_1500":"America/Anchorage",
    "TZ_1600":"America/Los_Angeles",
    "TZ_1700":"America/Denver",
    "TZ_1800":"America/Chicago",
    "TZ_1900":"America/New_York",
    "TZ_2100":"America/Sao_Paulo"
}

module.exports = {
    timezoneInfoObj
};